import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import IntlProps from "../../../../state/helpers/IntlProps"
import { SelectOption } from "../../../../state/helpers/SelectOption"
import Product from "../../../../state/product/Product"
import { MATRIX_AXIS_TYPE } from "../../../../state/product/Types"
import { MatrixAxis } from "../../../../state/product/matrix/Matrix"
import { MatrixItemDto } from "../../../../state/product/matrix/matrix-item/MatrixItem"
import { VariantsIds } from "../../../../state/product/pricingbrackets/PricingBrackets"
import Icon from "../../../icon/icon.component"
import MatrixAxisOptionsSelect from "./MatrixAxisOptionsSelect"

export type SelectedOptionsIds = {
    [MATRIX_AXIS_TYPE.X]: string,
    [MATRIX_AXIS_TYPE.Y]: string,
    [MATRIX_AXIS_TYPE.Z]: string,
}

export type FilteredOptionsIds = {
    [MATRIX_AXIS_TYPE.X]: string[],
    [MATRIX_AXIS_TYPE.Y]: string[],
    [MATRIX_AXIS_TYPE.Z]: string[],
}

type Props = {
    product: Product 
    hideIcon:boolean
    onMatrixItemSelect: (item: MatrixItemDto | undefined) => void
    onSelectedOptionIdsChange?:(item:VariantsIds[])=>void
    selectedMatrixItem: MatrixItemDto
}

const MatrixSelection = (props: Props & IntlProps) => {
    const matrix = props.product.getMatrix()
    const [selectedOptionsIds, setSelectedOptionsIds] = useState<SelectedOptionsIds>({
        [MATRIX_AXIS_TYPE.X]: "",
        [MATRIX_AXIS_TYPE.Y]: "",
        [MATRIX_AXIS_TYPE.Z]: "",
    })

    const [filteredOptionsIds, setFilteredOptionsIds] = useState<FilteredOptionsIds>({
        [MATRIX_AXIS_TYPE.X]: matrix.getAttributes().xAxis.options.map((o) => o.id),
        [MATRIX_AXIS_TYPE.Y]: matrix.getAttributes().yAxis.options.map((o) => o.id),
        [MATRIX_AXIS_TYPE.Z]: matrix.getAttributes().zAxis.options.map((o) => o.id),
    })

    const areOptionsSelectedForEveryAvailableAxis = () => {
        return matrix.getAxes().every(axis => !!selectedOptionsIds[axis.type])
    }

    useEffect( ()=> {
        if (props.selectedMatrixItem) {
            setSelectedOptionsIds({
                [MATRIX_AXIS_TYPE.X]: props.selectedMatrixItem.attributes.xMatrixAxisOptionId,
                [MATRIX_AXIS_TYPE.Y]: props.selectedMatrixItem.attributes.yMatrixAxisOptionId,
                [MATRIX_AXIS_TYPE.Z]: props.selectedMatrixItem.attributes.zMatrixAxisOptionId,
            })
        }
    }, [])

    useEffect(() => {
        setFilteredOptionsIds(matrix.getFilteredMatrixItemsOptionsIds(
            selectedOptionsIds[MATRIX_AXIS_TYPE.X],
            selectedOptionsIds[MATRIX_AXIS_TYPE.Y],
            selectedOptionsIds[MATRIX_AXIS_TYPE.Z]),
        )
    }, [selectedOptionsIds])

    useEffect(() => {
        if(areOptionsSelectedForEveryAvailableAxis()) {
            const item = matrix.findMatrixItem(
                selectedOptionsIds[MATRIX_AXIS_TYPE.X],
                selectedOptionsIds[MATRIX_AXIS_TYPE.Y],
                selectedOptionsIds[MATRIX_AXIS_TYPE.Z],
            )
            if (props.onMatrixItemSelect) {
                props.onMatrixItemSelect(item)
            }
        } else {
            if (props.onMatrixItemSelect) {
                props.onMatrixItemSelect(undefined)
            }
        }

        if (props.onSelectedOptionIdsChange) {
            props.onSelectedOptionIdsChange(matrix.findMatrixItems(
                selectedOptionsIds[MATRIX_AXIS_TYPE.X],
                selectedOptionsIds[MATRIX_AXIS_TYPE.Y],
                selectedOptionsIds[MATRIX_AXIS_TYPE.Z],))
        }
    }, [selectedOptionsIds])

    const onSelectChange = (axis: MatrixAxis, axisOptionSelected: SelectOption): void => {
        if (axisOptionSelected) {
            setSelectedOptionsIds(curr => ({
                ...curr,
                [axis.type]: axisOptionSelected.value
            }))
        } else {
            setSelectedOptionsIds(curr => ({
                ...curr,
                [axis.type]: ""
            }))
        }
    }

    return (
        <div className="row matrix-selection pt-0 pb-1 mb-2">
            {!props.hideIcon && <div className="col-md-7 d-none d-md-block">
                <Icon className={"matrix-selection-icon"} value={"cog"} />
            </div>}
            <div className="col-sm-12 col-md-5">
                <div className={props.hideIcon ? "row":""}>
                    {matrix.getAxes().map(a => (
                        <MatrixAxisOptionsSelect
                            key={a.type}
                            axis={a}
                            displayRow={props.hideIcon}
                            filteredOptionsIds={filteredOptionsIds}
                            selectedOptionsIds={selectedOptionsIds}
                            onSelectChange={onSelectChange}
                            isDisabled={props.selectedMatrixItem ? true : false}
                        />
                    ))}
                </div>
            </div>
        </div>

    )
}

export default injectIntl(MatrixSelection)


// WEBPACK FOOTER //
// ./src/common/pricing/add-item-modal/components/MatrixSelection.tsx